import React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { EU_COUNTRIES } from '@/lib/locale';
import { useRegions } from '@/lib/useRegions';

export const EMPTY_GEO = { country: 'all', region: '' };

export const inGeo = (item, geo) => {
  if (geo.country !== 'all' && (item.country || 'ES') !== geo.country) return false;
  if (geo.region && !(item.region || '').toLowerCase().includes(geo.region.trim().toLowerCase())) return false;
  return true;
};

export const isGeoActive = (geo) => geo.country !== 'all' || !!geo.region;

// Country + Region/Province filter used by surplus, auctions and suppliers lists.
const GeoFilter = ({ value, onChange, testPrefix = 'geo' }) => {
  const { t } = useTranslation();
  const regions = useRegions(value.country);
  return (
    <>
      <div className="min-w-[150px]">
        <Label className="text-xs text-slate-500">{t('common.country')}</Label>
        <Select value={value.country} onValueChange={(v) => onChange({ ...value, country: v, region: '' })}>
          <SelectTrigger data-testid={`${testPrefix}-filter-country`} className="h-9"><SelectValue /></SelectTrigger>
          <SelectContent className="max-h-72">
            <SelectItem value="all">{t('common.all')}</SelectItem>
            {EU_COUNTRIES.map(([c, n]) => <SelectItem key={c} value={c}>{n}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className="min-w-[150px]">
        <Label className="text-xs text-slate-500">{t('common.region')}</Label>
        {regions.length > 0 ? (
          <Select value={value.region || 'all'} onValueChange={(v) => onChange({ ...value, region: v === 'all' ? '' : v })}>
            <SelectTrigger data-testid={`${testPrefix}-filter-region`} className="h-9"><SelectValue placeholder="—" /></SelectTrigger>
            <SelectContent className="max-h-72">
              <SelectItem value="all">{t('common.all')}</SelectItem>
              {regions.map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}
            </SelectContent>
          </Select>
        ) : (
          <Input
            data-testid={`${testPrefix}-filter-region`}
            value={value.region}
            onChange={(e) => onChange({ ...value, region: e.target.value })}
            placeholder={value.country === 'all' ? t('auth.country') + ' →' : '—'}
            className="h-9"
            disabled={value.country === 'all'}
          />
        )}
      </div>
    </>
  );
};

export default GeoFilter;
